import React, {useEffect, useTransition} from "react";
import {useViewerStore} from "../../../../../../store/store";
import { MODULE_GRAPH, siteCalculationState } from "../../../../../../services/siteCalculationState";
import { useCalculationStates } from "../../../../../../hooks/calculationStateHook";
import { isIpadDevice } from "../../../Three-JS-Viewer/Controllers/Common";
import { CalculationType } from "../../../../../../@types/enums";
import { TotalSystemEfficiencyProps } from "../../../../../../@types/types";
import ProductionLoader from "./ProductionLoader";

const TotalSystemEfficiency: React.FC<TotalSystemEfficiencyProps> = ({popoutVersion}) => {
    const [isPending, startTransition] = useTransition();

    const utilityWattage = useViewerStore(state => state.utilityWattage);
    const totalSystemSize = useViewerStore(state => state.totalSystemSize);
    const actualWattage = useViewerStore(state => state.actualWattage);
    const efficiency = useViewerStore(state => state.efficiency);
    const modeCount = useViewerStore(state => state.modeCount);
    const multiplier = useViewerStore(state => state.multiplier);
    const solarAccess = useViewerStore(state => state.weightedSolarAverage);
    const SFannualUsage = useViewerStore(state => state.SFannualUsage)
    const {needsUpdate} = useCalculationStates([CalculationType.ACCESS_MULTI, CalculationType.IDEAL_MULTI, CalculationType.MODULE_GRAPH]);

    const fontSizeStyle = {
        popOutStyle: {
            fontSize: '15px'
        },
        iPadStyle: {
            fontSize: '13px'
        },
        rightHandMenuStyle: {
            fontSize: '13px'
        },
        popOutWidth: {
            width: '300px',
            border: "0px"
        },
        rightHandMenuWidth: {
            width: '230px',
            border: "0px"
        }
    };

    useEffect(() => {
        if (needsUpdate[MODULE_GRAPH]) {
            startTransition(() => {
                siteCalculationState.useCalculations(CalculationType.MODULE_GRAPH);
            })
        }
    }, [needsUpdate]);

    return (

        <>
            {
                isPending || (Object.values(needsUpdate).includes(true)) ?
                    <ProductionLoader isPopoutVersion={popoutVersion}/>
                    :

                    <>
                        <div className={"Thermometer_Production_Container"}
                             style={{position: "relative", left: "10px"}}>
                            <div id="termometer">
                                <div className="temperature" data-value={efficiency + '%'} style={{
                                    height: efficiency + '%',
                                }}></div>
                                <div id="graduations"></div>
                            </div>

                            <div className='tab__data'
                                 style={popoutVersion ? fontSizeStyle.popOutWidth : fontSizeStyle.rightHandMenuWidth}>
                                <ul className='tab__data--list' style={{gap: "3px", margin: "5px 0", position: "relative", left: "15px"}}>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>System Size: </span>
                                        <span
                                            style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{(Number(totalSystemSize)).toFixed(3)} kW DC</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Modules:</span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{modeCount}</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Efficiency (TSRF):</span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{efficiency}</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Multiplier:</span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{multiplier}</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Solar Access:</span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{solarAccess}</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>kWh - Utility: </span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{Math.round(Number(utilityWattage))?.toLocaleString()}</span>
                                    </li>
                                    <li>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>kWh - Actual: </span>
                                        <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{Math.round(Number(actualWattage))?.toLocaleString()}</span>
                                    </li>
                                    {SFannualUsage &&
                                    <>
                                        <li>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Utility Offset: </span>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{Math.round(Number(utilityWattage) / SFannualUsage * 100)}%</span>
                                        </li>
                                        <li>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Actual Offset: </span>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{Math.round(Number(actualWattage) / SFannualUsage * 100)}%</span>
                                        </li>
                                        <li>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>Annual Usage: </span>
                                            <span style={popoutVersion ? isIpadDevice() ? fontSizeStyle.iPadStyle : fontSizeStyle.popOutStyle : fontSizeStyle.rightHandMenuStyle}>{SFannualUsage.toLocaleString()}</span>
                                        </li>
                                    </>
                                    }
                                </ul>
                            </div>
                        </div>

                    </>
            }
        </>

    )


}

export default TotalSystemEfficiency;
